import { render, staticRenderFns } from "./UngradedSubmissions.vue?vue&type=template&id=da71fad8&"
import script from "./UngradedSubmissions.vue?vue&type=script&lang=js&"
export * from "./UngradedSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports